var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14C0.5 6.51781 6.51781 0.5 14 0.5C21.4822 0.5 27.5 6.51781 27.5 14C27.5 21.4822 21.4822 27.5 14 27.5C6.51781 27.5 0.5 21.4822 0.5 14Z",
    stroke: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2333 9.68333C21.2041 9.65417 21.1895 9.625 21.1749 9.59583C21.1603 9.56667 21.1458 9.5375 21.1166 9.50833L17.0333 5.425C16.9749 5.36667 16.9166 5.30833 16.8583 5.30833C16.7999 5.25 16.6833 5.25 16.6249 5.25H9.04159C8.69159 5.25 8.45825 5.48333 8.45825 5.83333V10.6667H7.20825C6.93211 10.6667 6.70825 10.8905 6.70825 11.1667V18.9167C6.70825 19.1928 6.93211 19.4167 7.20825 19.4167H8.45825V22.1667C8.45825 22.5167 8.69159 22.75 9.04159 22.75H20.7083C21.0583 22.75 21.2916 22.5167 21.2916 22.1667V9.91667C21.2916 9.85833 21.2916 9.74167 21.2333 9.68333ZM9.62492 6.41667V10.6667H14.9583C15.2344 10.6667 15.4583 10.8905 15.4583 11.1667V18.9167C15.4583 19.1928 15.2344 19.4167 14.9583 19.4167H9.62492V21.5833H20.1249V10.5H16.6249C16.2749 10.5 16.0416 10.2667 16.0416 9.91667V6.41667H9.62492ZM17.2083 7.23333L19.3083 9.33333H17.2083V7.23333ZM10.5291 14.9833L9.18742 17.0833H10.1208L11.0541 15.5667L11.9874 17.0833H12.9791L11.5791 15.0417L12.8624 13H11.9291L11.0541 14.4583L10.1791 13H9.24575L10.5291 14.9833Z",
    fill: "#0F7B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.c4d5d2946881b27b0cc28aba88a9f682.svg";
export { ForwardRef as ReactComponent };